// extracted by mini-css-extract-plugin
export default {"whatsappFloat":"whatsappWidget_whatsappFloat__oLRFn","whatsapp-icon":"whatsappWidget_whatsapp-icon__fvY4G"};